import React, { useState } from "react";
import { FiPlus } from "react-icons/fi";
import "../styles/Dashboard.css";
import AdminWorkForce from "./AdminWorkForce";
import CleanerWorkForce from "./CleanerWorkForce";
import ManagerWorkForce from "./ManagerWorkForce";
import ContractorWorkForce from "./ContractorWorkForce";
import AddMember from "./AddMember";
import { useAdminPageSearch } from "../../../utils/useAdminPageSearch";

const ROLE_TABS = ["Admin", "Manager", "Cleaner", "Contractor"];

function Admin({ refreshKey }) {
  return <AdminWorkForce refreshKey={refreshKey} />;
}
function Manager({ refreshKey }) {
  return <ManagerWorkForce refreshKey={refreshKey} />;
}
function Cleaner({ refreshKey }) {
  return <CleanerWorkForce refreshKey={refreshKey} />;
}
function Contractor({ refreshKey }) {
  return <ContractorWorkForce refreshKey={refreshKey} />;
}

export default function DashboardWorkForce({ initialTab, autoOpenAddMember, onContractorAdded, onCancelAddMember }) {
  const { get, patch } = useAdminPageSearch();
  const urlTab = get("tab");
  const activeTab =
    initialTab && ROLE_TABS.includes(initialTab)
      ? initialTab
      : ROLE_TABS.includes(urlTab)
        ? urlTab
        : "Admin";
  const [refreshKey, setRefreshKey] = useState(0);
  const [dismissedAutoAdd, setDismissedAutoAdd] = useState(false);
  const showAddMember =
    (Boolean(autoOpenAddMember) && !dismissedAutoAdd) ||
    get("action") === "add";

  const handleCloseAddMember = () => {
    setDismissedAutoAdd(true);
    if (onCancelAddMember) {
      onCancelAddMember();
    } else {
      patch({}, ["action"]);
    }
  };

  const handleMemberAdded = () => {
    setDismissedAutoAdd(true);
    if (!autoOpenAddMember) {
      patch({}, ["action"]);
    }
    setTimeout(() => {
      setRefreshKey((prev) => prev + 1);
    }, 300);
    if (activeTab === "Contractor" && onContractorAdded) {
      onContractorAdded();
    }
  };

  const selectTab = (tab) => {
    patch({ tab }, ["view", "edit"]);
  };

  const renderComponent = () => {
    if (showAddMember) {
      return (
        <AddMember
          onClose={handleCloseAddMember}
          onMemberAdded={handleMemberAdded}
          memberType={activeTab}
        />
      );
    }

    switch (activeTab) {
      case "Admin":
        return <Admin refreshKey={refreshKey} />;
      case "Manager":
        return <Manager refreshKey={refreshKey} />;
      case "Cleaner":
        return <Cleaner refreshKey={refreshKey} />;
      case "Contractor":
        return <Contractor refreshKey={refreshKey} />;
      default:
        return <Admin refreshKey={refreshKey} />;
    }
  };

  return (
    <div className="dashboard">
      {/* Top Navbar */}
      <div className="navbar-workforce">
        <div className="nav-left">
          {["Admin", "Manager", "Cleaner", "Contractor"].map((tab) => (
            <button
              key={tab}
              className={`nav-btn ${activeTab === tab ? "active" : ""}`}
              onClick={() => selectTab(tab)}
              disabled={showAddMember} // disable tabs when AddMember is open
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="nav-middle">
          <input
            type="text"
            placeholder="Search..."
            className="search-bar"
            disabled={showAddMember} // disable search when AddMember is open
          />
        </div>

        <div className="nav-right">
          <button
            className="workforce-add-btn"
            onClick={() => {
              if (!autoOpenAddMember) patch({ action: "add" }, ["view", "edit"]);
            }}
          >
            <FiPlus size={18} /> {activeTab}
          </button>
        </div>
      </div>

      {/* Rendered Component */}
      <div className="main-content">{renderComponent()}</div>
    </div>
  );
}
